import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FileListComponent } from '../file-download/file-list/file-list.component';
import { OriginalFileNameModel } from '../../types/file-signature';
import { FileStore } from '../../stores/file.store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-download-helper',
  imports: [CommonModule, MatProgressBarModule, MatProgressSpinnerModule, FileListComponent],
  templateUrl: './download-helper.component.html',
  styleUrl: './download-helper.component.scss'
})
export class DownloadHelperComponent implements OnInit {
  isDownloading = false;
  showProgressIndicator = false; // インジケーター表示フラグ
  downloadProgress = 0;
  downloadStatus = 'ダウンロードを準備中...';
  fileName = '';
  originFileNameList: OriginalFileNameModel[] = [];
  resultText = 'しばらくお待ちください...'

  private _fileStore = inject(FileStore);
  private _router = inject(Router);

  ngOnInit(): void {
    const sasuri = this._fileStore.getSasUri();
    if (sasuri === null) {
      this._router.navigate(['/error/invalid-signature']);
    }
    this.fileName = this._fileStore.getDownloadFileName() || 'downloaded_file';
    this.originFileNameList = this._fileStore.getOriginalFileNames();
    if (sasuri) {
      this.startDownload(sasuri);
    }
  }

  private async startDownload(sasuri: string): Promise<void> {
    try {
      this.isDownloading = true;
      this.downloadStatus = `${this.fileName} をダウンロード中...`;

      // 直接ダウンロード
      this.downloadStatus = `${this.fileName} を直接ダウンロード中...`;
      this.resultText = 'ブラウザの標準ダウンロード機能を使用します。';
      // Content-Dispositionヘッダーを設定して直接ダウンロード
      const enhancedSasUri = this.enhanceSasUriForDownload(sasuri);
      const link = document.createElement('a');
      link.href = enhancedSasUri;
      link.download = this.fileName || 'downloadFile';
      link.target = '_self';
      link.rel = 'noopener';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.downloadStatus = 'ダウンロード開始';
      this.resultText = 'ダウンロードが開始されました。ブラウザのダウンロード状況をご確認ください。\nダウンロード開始後は、このページやブラウザを閉じても問題ありません。';
      this.isDownloading = false;
      this.showProgressIndicator = false;
      return;
    } catch (error) {
      console.error('ダウンロードエラー:', error);
      this.downloadStatus = 'ダウンロードに失敗しました';
      this.isDownloading = false;
      this.showProgressIndicator = false;
    }
  }

  private enhanceSasUriForDownload(sasuri: string): string {
  try {
    const url = new URL(sasuri);

    // ファイル名をURLエンコード
    const encodedFileName = encodeURIComponent(this.fileName);

    // Content-Dispositionパラメータを追加
    url.searchParams.set('response-content-disposition', `attachment; filename*=UTF-8''${encodedFileName}`);

    return url.toString();
  } catch (error) {
    console.warn('SAS URI enhancement failed, using original:', error);
    return sasuri;
  }
}

  // ファイルサイズを変換
  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
